import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "loginRegisterModalHeadlineId",
  tabindex: "-1",
  class: "m-0 mb-6 text-[2rem] font-semibold leading-[2.714285714rem]"
}

import { store } from "@/state/store";
import useIsMobile from "@/services/detectingMobile";

export default /*#__PURE__*/_defineComponent({
  __name: 'HeadlineModalDesktop',
  setup(__props) {

const { isMobile } = useIsMobile();

return (_ctx: any,_cache: any) => {
  return (!_unref(isMobile) && _unref(store).isModal)
    ? (_openBlock(), _createElementBlock("h2", _hoisted_1, _toDisplayString(_ctx.$t(_unref(store).isLogin ? "login.headline" : "registration.headline")), 1))
    : _createCommentVNode("", true)
}
}

})